import { Link } from "react-router-dom";
import Search from "../../MainContent/Search/Search";
import Marquee from "../../Marquee/Marquee";

const HistoryMinistry = () => {
    return (
        <div className="container">
            <Search />
            <h4 class="pb-4 pt-4 mb-4 border-bottom ">
                Таърихи вазорат
            </h4>
            <div style={{ "display": "flex", "justify-content": "center" }}>
                <img src="https://maorif.tj/storage/posts/April2017/IEfpU8fX2jQBfYo7nKyC.jpg" class="img-fluid img-thumbnail" alt="Wild Landscape" />
            </div >

            <div class="row pt-5 pb-4">
                <div class="col-sm-4">
                    <div class="card" style={{ "height": "200px" }}>
                        <div class="card-body" >
                            <h5 class=" text-center">Пайдоиш ва инкишофи мактабҳо то зуҳури ислом</h5>

                        </div>
                        <div style={{ "display": "flex", "justify-content": "center" }}>
                            <p>
                                <Link to={'/'} class="btn btn-warning">давомаш</Link>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="card" style={{ "height": "200px" }}>
                        <div class="card-body" >
                            <h5 class="card-title text-center">Таълиму тарбия дар давраи ғуломдорӣ (дар давлатҳои Бохтар, Порт, Ҳахоманишҳо, Ашкониён ва Сосониён)</h5>


                        </div>
                        <div style={{ "display": "flex", "justify-content": "center" }}>
                            <p>
                                <Link to={'/'} class="btn btn-warning">давомаш</Link>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="card" style={{ "height": "200px" }}>
                        <div class="card-body">
                            <h5 class="card-title  text-center">Таълиму тарбияи халқи тоҷик дар давраи истилои араб</h5>
                        </div>
                        <div style={{ "display": "flex", "justify-content": "center" }}>
                            <p>
                                <Link to={'/'} class="btn btn-warning">давомаш</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pb-4">
                <div class="col-sm-4">
                    <div class="card" style={{ "height": "200px" }}>
                        <div class="card-body">
                            <h5 class="card-title  text-center">Мактаб ва ақидаҳои педагогии халқи тоҷик дар қарнҳои IX-XVI</h5>
                        </div>
                        <div style={{ "display": "flex", "justify-content": "center" }}>
                            <p>
                                <Link to={'/'} class="btn btn-warning">давомаш</Link>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="card" style={{ "height": "200px" }}>
                        <div class="card-body">
                            <h5 class="card-title  text-center">Вазъи таълиму тарбияи халқи тоҷик дар давраи ҳокимияти муғулҳо ва темуриён</h5>
                        </div>
                        <div style={{ "display": "flex", "justify-content": "center" }}>
                            <p>
                                <Link to={'/'} class="btn btn-warning">давомаш</Link>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="card" style={{ "height": "200px" }}>
                        <div class="card-body">
                            <h5 class="card-title  text-center">Мактабу маорифи тоҷик аз қарнҳои XVII то ибтидои қарни XX (то даврони Инқилоби Октябр)</h5>
                        </div>
                        <div style={{ "display": "flex", "justify-content": "center" }}>
                            <p>
                                <Link to={'/'} class="btn btn-warning">давомаш</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pb-4">
                <div class="col-sm-4">
                    <div class="card" style={{ "height": "200px" }}>
                        <div class="card-body">
                            <h5 class="card-title  text-center">Инқилоби Октябр ва таҳаввули соҳаи маориф (солҳои 1917-1940)</h5>
                        </div>
                        <div style={{ "display": "flex", "justify-content": "center" }}>
                            <p>
                                <Link to={'/'} class="btn btn-warning">давомаш</Link>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="card" style={{ "height": "200px" }}>
                        <div class="card-body">
                            <h5 class="card-title  text-center">Маориф дар солҳои Ҷанги Бузурги Ватанӣ ва баъд аз он (1941-1958)</h5>
                        </div>
                        <div style={{ "display": "flex", "justify-content": "center" }}>
                            <p>
                                <Link to={'/'} class="btn btn-warning">давомаш</Link>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="card" style={{ "height": "200px" }}>
                        <div class="card-body">
                            <h5 class="card-title  text-center">Маориф дар солҳои 1958-1991 (То истиқлолияти давлатии Ҷумҳурии Тоҷикистон)</h5>
                        </div>
                        <div style={{ "display": "flex", "justify-content": "center" }}>
                            <p>
                                <Link to={'/'} class="btn btn-warning">давомаш</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <div class="card" style={{ "height": "200px" }}>
                        <div class="card-body">
                            <h5 class="card-title  text-center">Рушди маориф ва илм дар даврони истиқлолияти давлатӣ (1991-2016)</h5>
                        </div>
                        <div style={{ "display": "flex", "justify-content": "center" }}>
                            <p>
                                <Link to={'/'} class="btn btn-warning">давомаш</Link>
                            </p>
                        </div>
                    </div>
                </div>


            </div>
            <Marquee />
        </div >
    )
}

export default HistoryMinistry;